

<head>
  <title>{{appName}}</title>
</head>
<body>
  <router-outlet></router-outlet>
</body>

